
import Grid from "@mui/material/Grid";

// EGEAD Fulfilment POD components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// EGEAD Fulfilment POD example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Custom Combined Chart - Chart tổng hợp hiển thị tất cả trong 1 chart
import CombinedChart from "components/Charts/CombinedChart";
// Store Report Table - Bảng báo cáo tổng thể theo store
import StoreReportTable from "components/Charts/StoreReportTable";

// Dashboard components
import { Card, Switch } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import InventoryIcon from '@mui/icons-material/Inventory';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import moment from "moment";
import { useState, useEffect, useCallback } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import { GET } from "api";
import bcrypt from "bcryptjs";
import { NotificationManager } from "react-notifications";

function Dashboard() {
  const user = useSelector((state) => state.user.user);

  // Chỉ lấy filter states từ Redux (được dùng chung với các trang khác)
  const startDate = useSelector((state) => state.user.startDate);
  const endDate = useSelector((state) => state.user.endDate);
  const filterStore = useSelector((state) => state.user.filterStore);
  const order_status = useSelector((state) => state.user.order_status);
  
  // Type dùng local state cho dashboard, không cần Redux
  const [type, setType] = useState(false);

  // Dashboard data dùng local state thay vì Redux (chỉ dùng trong trang này)
  const [dashboard, setDashboard] = useState({
    order: 0,
    price: 0,
    basecost: 0,
    cancel: 0,
    sku: { other: [], total: {} },
    statistics: {},
    storeRevenue: {},
    storeStatistics: {}
  });
  const [loading, setLoading] = useState(false);

  // Fetch dashboard data - gọi API trực tiếp, không qua Redux
  const fetchDashboardData = useCallback(async () => {
    if (!user) return;

    setLoading(true);
    try {
      const salt = await bcrypt.genSalt(10);
      const hash = await bcrypt.hash(`${user}đố tuấn anh phá được`, salt);

      // Gọi API trực tiếp thay vì qua Redux
      const response = await GET("/dashboard", {
        startDate: moment(startDate).startOf("day").format("x"),
        endDate: moment(endDate).endOf("day").format("x"),
        store: filterStore,
        order_status,
        version: hash,
        type
      });

      // Lưu vào local state
      if (response?.data) {
        setDashboard(response.data);
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      NotificationManager.error('Server not responding!', 'Error', 1000);
      setDashboard({
        price: 0,
        basecost: 0,
        order: 0,
        cancel: 0,
        sku: { other: [], total: {} },
        statistics: {},
        storeRevenue: {},
        storeStatistics: {}
      });
    } finally {
      setLoading(false);
    }
  }, [user, startDate, endDate, filterStore, order_status, type]);

  // Chỉ fetch khi component mount hoặc filters thay đổi
  useEffect(() => {
    fetchDashboardData();
  }, [fetchDashboardData]);

  const handleToggle = (event) => {
    const newType = event.target.checked;
    // Update local state cho type
    setType(newType);
    // useEffect sẽ tự động gọi lại API khi type thay đổi
  };

  // Format số với dấu phẩy
  const formatNumber = (num) => {
    if (!num && num !== 0) return '0';
    return Number(num).toLocaleString('en-US');
  };

  // Format currency với dấu phẩy
  const formatCurrency = (amount) => {
    if (!amount && amount !== 0) return '$0.00';
    const num = typeof amount === 'string' ? parseFloat(amount) : amount;
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num);
  };

  // Tính cancel rate
  const cancelRate = dashboard?.order && dashboard?.order > 0
    ? ((dashboard.cancel / dashboard.order) * 100).toFixed(2)
    : '0.00';

  // Tính success rate
  const successRate = dashboard?.order && dashboard?.order > 0
    ? (((dashboard.order - dashboard.cancel) / dashboard.order) * 100).toFixed(2)
    : '0.00';

  // Tính profit
  const profit = (parseFloat(dashboard?.price || 0) - parseFloat(dashboard?.basecost || 0)).toFixed(2);
  const profitRate = dashboard?.price && parseFloat(dashboard.price) > 0
    ? ((parseFloat(profit) / parseFloat(dashboard.price)) * 100).toFixed(2)
    : '0.00';

  // Số stores
  const storeCount = dashboard?.storeRevenue ? Object.keys(dashboard.storeRevenue).length : 0;
  const labels = dashboard?.sku ? Object.keys(dashboard?.sku.total) : [];
  const data = dashboard?.sku ? Object.values(dashboard?.sku.total) : [];
  const chartData = {
    labels: labels,
    datasets: {
      label: "SKU",
      data: data
    }
  };

  const labels2 = dashboard?.sku ? Object.keys(dashboard?.statistics) : [];
  const data2 = dashboard?.sku ? Object.values(dashboard?.statistics) : [];

  // Cấu trúc dữ liệu cho biểu đồ
  const chartData2 = {
    labels: labels2,
    datasets: {
      label: "Design",
      data: data2
    }
  };


  const data4 = dashboard?.storeRevenue ? Object.values(dashboard?.storeRevenue) : [];
  const labels3 = dashboard?.storeStatistics ? Object.keys(dashboard?.storeStatistics) : [];
  const data3 = dashboard?.storeStatistics ? Object.values(dashboard?.storeStatistics) : [];
  const chartData3 = {
    labels: labels3,
    datasets: [
      {
        label: "Order",
        data: data3
      }, {
        label: "Revenue",
        data: data4
      }
    ],
  };
  const processDataByDate = (storeStatistics) => {
    const dateMap = {};

    // Loop through each store's statistics
    Object.keys(storeStatistics).forEach(storeName => {
      const dates = storeStatistics[storeName];

      // Loop through each date for the store
      Object.keys(dates).forEach(date => {
        if (!dateMap[date]) {
          dateMap[date] = { date };
        }
        dateMap[date][storeName] = {
          orders: dates[date].order,
          totalPrice: dates[date].totalPrice
        };
      });
    });

    // Convert dateMap to array of rows
    return Object.values(dateMap);
  };

  // Helper function to sort dates in DD/MM/YYYY format
  const sortDates = (dateStrings) => {
    return dateStrings.sort((a, b) => {
      // Parse DD/MM/YYYY format
      const parseDate = (dateStr) => {
        const [day, month, year] = dateStr.split('/').map(Number);
        return new Date(year, month - 1, day);
      };
      return parseDate(a) - parseDate(b);
    });
  };

  const DynamicTable = () => {
    // Get all unique dates from all stores
    const allDatesSet = new Set();
    Object.keys(dashboard?.storeStatistics || {}).forEach(storeName => {
      Object.keys(dashboard?.storeStatistics[storeName] || {}).forEach(date => {
        allDatesSet.add(date);
      });
    });
    const dates = sortDates(Array.from(allDatesSet)); // Sort dates correctly
    const stores = Object.keys(dashboard?.storeStatistics || {}).sort(); // Get the list of stores

    return (
      <div style={{ border: '1px solid #ddd', padding: '10px', borderRadius: '5px', overflow: 'hidden', width: '100%', textAlign: "right", marginLeft: 24 }}>
        <div >
          <Switch
            checked={type}
            onChange={handleToggle}
            style={{ marginRight: '8px' }}
          />
          <span style={{ fontSize: "12px", fontWeight: "bold" }}>* 0.9 Revenue</span>
        </div>

        <div style={{ overflow: 'auto' }}>
          <table className="google-sheets-table">
            <thead>
              <tr>
                <th >Date</th>
                {stores.map((store) => (
                  <th colSpan="5" key={store}>{store}</th> // Store name spans 5 columns
                ))}
              </tr>
              <tr >
                <th ></th>
                {stores.map((store) => (
                  <>
                    <th style={{ backgroundColor: "#ff9900" }}>Revenue</th>
                    <th style={{ backgroundColor: "#ff9900" }}>Basecost</th>
                    {/* <th style={{ backgroundColor: "#ff9900" }}>Basecost/Revenue</th> */}
                    <th style={{ backgroundColor: "#ff9900" }}>Orders</th>
                    <th style={{ backgroundColor: "#ff9900" }}>Ads</th>
                    <th style={{ backgroundColor: "#ff9900" }}>Profit</th>
                  </>
                ))}
              </tr>
            </thead>
            <tbody>
              {dates.map((date) => (
                <tr key={date}>
                  <td className="sticky-col">{date}</td>
                  {stores.map((store) => {
                    const totalPrice = dashboard?.storeStatistics[store]?.[date]?.totalPrice ? type ? dashboard?.storeStatistics[store]?.[date]?.totalPrice * 0.9 : dashboard?.storeStatistics[store]?.[date]?.totalPrice : 0;
                    const baseCost = dashboard?.storeStatistics[store]?.[date]?.basecost || 0; // Base cost is currently 0
                    const orders = dashboard?.storeStatistics[store]?.[date]?.order || 0;
                    const priceAds = 0; // Price ads is currently 0
                    const profit = totalPrice - baseCost - priceAds;

                    return (
                      <>
                        <td style={{ backgroundColor: "#d9ead3" }}>{totalPrice ? totalPrice.toFixed(2) : 0}</td>
                        <td>{baseCost ? baseCost.toFixed(2) : 0}</td>
                        {/* <td>{baseCost && totalPrice ? `${(100 / totalPrice * baseCost).toFixed(2)}%` : 0}</td> */}
                        <td style={{ color: "#1869ff" }}>{orders}</td>
                        <td>{priceAds ? priceAds.toFixed(2) : 0}</td>
                        <td>{profit.toFixed(2)}</td>
                      </>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        {loading && (
          <MDBox display="flex" justifyContent="center" alignItems="center" py={4}>
            <MDTypography variant="body2" color="text">
              Đang tải dữ liệu...
            </MDTypography>
          </MDBox>
        )}
        {/* Cards và Chart cùng hàng */}
        <Grid container spacing={3} sx={{ mb: 4 }}>
          {/* Box chứa các cards bên trái */}
          <Grid item xs={12} md={4} lg={3} sx={{ display: 'flex' }}>
            <Card sx={{
              p: 2,
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              borderRadius: 2
            }}>
              <MDBox
                sx={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: 2,
                  height: '100%'
                }}
              >
                {/* Orders Card */}
                <MDBox
                  p={2}
                  sx={{
                    backgroundColor: '#f8f9fa',
                    borderRadius: 1.5,
                    border: '1px solid #e9ecef',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    minHeight: '120px',
                    position: 'relative',
                    overflow: 'hidden',
                    '&:hover': {
                      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                      transform: 'translateY(-2px)',
                      transition: 'all 0.3s ease'
                    }
                  }}
                >
                  <MDBox sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                    <ShoppingCartIcon sx={{ color: '#6c757d', fontSize: 20 }} />
                    <MDTypography
                      variant="caption"
                      sx={{
                        color: '#6c757d',
                        fontSize: '11px',
                        fontWeight: 600,
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                      }}
                    >
                      Orders
                    </MDTypography>
                  </MDBox>
                  <MDTypography
                    variant="h5"
                    sx={{
                      fontWeight: 700,
                      color: '#212529',
                      fontSize: '24px',
                      lineHeight: 1.2,
                      mb: 0.5
                    }}
                  >
                    {formatNumber(dashboard?.order || 0)}
                  </MDTypography>
                  <MDBox sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 1 }}>
                    <TrendingUpIcon sx={{ color: '#28a745', fontSize: 14 }} />
                    <MDTypography
                      variant="caption"
                      sx={{
                        color: '#28a745',
                        fontSize: '10px',
                        fontWeight: 600
                      }}
                    >
                      {storeCount} stores
                    </MDTypography>
                  </MDBox>
                </MDBox>

                {/* Revenue Card */}
                <MDBox
                  p={2}
                  sx={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    borderRadius: 1.5,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    minHeight: '120px',
                    position: 'relative',
                    overflow: 'hidden',
                    '&:hover': {
                      boxShadow: '0 4px 16px rgba(102, 126, 234, 0.4)',
                      transform: 'translateY(-2px)',
                      transition: 'all 0.3s ease'
                    }
                  }}
                >
                  <MDBox sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                    <AttachMoneyIcon sx={{ color: 'rgba(255,255,255,0.9)', fontSize: 20 }} />
                    <MDTypography
                      variant="caption"
                      sx={{
                        color: 'rgba(255,255,255,0.9)',
                        fontSize: '11px',
                        fontWeight: 600,
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                      }}
                    >
                      Revenue
                    </MDTypography>
                  </MDBox>
                  <MDTypography
                    variant="h5"
                    sx={{
                      fontWeight: 700,
                      color: '#fff',
                      fontSize: '20px',
                      lineHeight: 1.2,
                      mb: 0.5
                    }}
                  >
                    {formatCurrency(dashboard?.price || 0)}
                  </MDTypography>
                  <MDBox sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 1 }}>
                    <TrendingUpIcon sx={{ color: 'rgba(255,255,255,0.8)', fontSize: 14 }} />
                    <MDTypography
                      variant="caption"
                      sx={{
                        color: 'rgba(255,255,255,0.9)',
                        fontSize: '10px',
                        fontWeight: 600
                      }}
                    >
                      Profit: {formatCurrency(profit)} ({profitRate}%)
                    </MDTypography>
                  </MDBox>
                </MDBox>

                {/* Basecost Card */}
                <MDBox
                  p={2}
                  sx={{
                    background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                    borderRadius: 1.5,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    minHeight: '120px',
                    position: 'relative',
                    overflow: 'hidden',
                    '&:hover': {
                      boxShadow: '0 4px 16px rgba(245, 87, 108, 0.4)',
                      transform: 'translateY(-2px)',
                      transition: 'all 0.3s ease'
                    }
                  }}
                >
                  <MDBox sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                    <InventoryIcon sx={{ color: 'rgba(255,255,255,0.9)', fontSize: 20 }} />
                    <MDTypography
                      variant="caption"
                      sx={{
                        color: 'rgba(255,255,255,0.9)',
                        fontSize: '11px',
                        fontWeight: 600,
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                      }}
                    >
                      Basecost
                    </MDTypography>
                  </MDBox>
                  <MDTypography
                    variant="h5"
                    sx={{
                      fontWeight: 700,
                      color: '#fff',
                      fontSize: '20px',
                      lineHeight: 1.2,
                      mb: 0.5
                    }}
                  >
                    {formatCurrency(dashboard?.basecost || 0)}
                  </MDTypography>
                  <MDBox sx={{ mt: 1 }}>
                    <MDBox sx={{
                      width: '100%',
                      height: 4,
                      backgroundColor: 'rgba(255,255,255,0.3)',
                      borderRadius: 2,
                      overflow: 'hidden',
                      mb: 0.5
                    }}>
                      <MDBox sx={{
                        width: `${dashboard?.price ? (parseFloat(dashboard.basecost || 0) / parseFloat(dashboard.price) * 100) : 0}%`,
                        height: '100%',
                        backgroundColor: 'rgba(255,255,255,0.8)',
                        transition: 'width 0.3s ease'
                      }} />
                    </MDBox>
                    <MDTypography
                      variant="caption"
                      sx={{
                        color: 'rgba(255,255,255,0.9)',
                        fontSize: '10px',
                        fontWeight: 500
                      }}
                    >
                      {dashboard?.price ? (parseFloat(dashboard.basecost || 0) / parseFloat(dashboard.price) * 100).toFixed(1) : 0}% of revenue
                    </MDTypography>
                  </MDBox>
                </MDBox>

                {/* Success/Cancel Card */}
                <MDBox
                  p={2}
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: 1.5,
                    border: '1px solid #e9ecef',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    minHeight: '120px',
                    position: 'relative',
                    overflow: 'hidden',
                    '&:hover': {
                      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                      transform: 'translateY(-2px)',
                      transition: 'all 0.3s ease'
                    }
                  }}
                >
                  <MDBox sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                    <MDBox sx={{ display: 'flex', gap: 0.5 }}>
                      <CheckCircleIcon sx={{ color: '#28a745', fontSize: 18 }} />
                      <CancelIcon sx={{ color: '#dc3545', fontSize: 18 }} />
                    </MDBox>
                    <MDTypography
                      variant="caption"
                      sx={{
                        color: '#6c757d',
                        fontSize: '11px',
                        fontWeight: 600,
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                      }}
                    >
                      Status
                    </MDTypography>
                  </MDBox>
                  <MDBox>
                    <MDBox sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5, mb: 1 }}>
                      <MDTypography
                        variant="h5"
                        sx={{
                          fontWeight: 700,
                          color: '#28a745',
                          fontSize: '22px',
                          lineHeight: 1.2
                        }}
                      >
                        {formatNumber((dashboard?.order || 0) - (dashboard?.cancel || 0))}
                      </MDTypography>
                      <MDTypography
                        variant="body2"
                        sx={{
                          color: '#9e9e9e',
                          fontSize: '14px',
                          fontWeight: 500
                        }}
                      >
                        /
                      </MDTypography>
                      <MDTypography
                        variant="h5"
                        sx={{
                          fontWeight: 700,
                          color: '#dc3545',
                          fontSize: '22px',
                          lineHeight: 1.2
                        }}
                      >
                        {formatNumber(dashboard?.cancel || 0)}
                      </MDTypography>
                    </MDBox>
                    <MDBox sx={{
                      width: '100%',
                      height: 6,
                      backgroundColor: '#e9ecef',
                      borderRadius: 3,
                      overflow: 'hidden',
                      mb: 0.5
                    }}>
                      <MDBox sx={{
                        width: `${successRate}%`,
                        height: '100%',
                        backgroundColor: '#28a745',
                        transition: 'width 0.3s ease'
                      }} />
                    </MDBox>
                    <MDBox sx={{ display: 'flex', justifyContent: 'space-between', mt: 0.5 }}>
                      <MDTypography
                        variant="caption"
                        sx={{
                          color: '#28a745',
                          fontSize: '10px',
                          fontWeight: 600
                        }}
                      >
                        {successRate}% success
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        sx={{
                          color: '#dc3545',
                          fontSize: '10px',
                          fontWeight: 600
                        }}
                      >
                        {cancelRate}% cancel
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>

          {/* Chart bên phải */}
          <Grid item xs={12} md={8} lg={9} sx={{ display: 'flex' }}>
            {(() => {
              if (!dashboard?.storeStatistics || Object.keys(dashboard.storeStatistics).length === 0) {
                return (
                  <Card sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                    <MDTypography variant="body2" color="text">
                      Không có dữ liệu chart
                    </MDTypography>
                  </Card>
                );
              }

              // Kết hợp tất cả stores thành 1 chart tổng thể
              const allDates = new Set();
              Object.keys(dashboard.storeStatistics).forEach(storeName => {
                Object.keys(dashboard.storeStatistics[storeName]).forEach(date => {
                  allDates.add(date);
                });
              });

              // Sắp xếp dates từ nhỏ đến lớn (format DD/MM/YYYY)
              const sortedDates = sortDates(Array.from(allDates));

              // Tính tổng theo date từ tất cả stores
              const totalOrders = sortedDates.map(date => {
                let total = 0;
                Object.keys(dashboard.storeStatistics).forEach(storeName => {
                  total += dashboard.storeStatistics[storeName][date]?.order || 0;
                });
                return { label: date, value: total };
              });

              const totalRevenue = sortedDates.map(date => {
                let total = 0;
                Object.keys(dashboard.storeStatistics).forEach(storeName => {
                  const price = dashboard.storeStatistics[storeName][date]?.totalPrice || 0;
                  total += type ? price * 0.9 : price; // Áp dụng type nếu cần
                });
                return { label: date, value: Math.round(total) };
              });

              const totalBasecost = sortedDates.map(date => {
                let total = 0;
                Object.keys(dashboard.storeStatistics).forEach(storeName => {
                  total += dashboard.storeStatistics[storeName][date]?.basecost || 0;
                });
                return { label: date, value: Math.round(total) };
              });

              return (
                <MDBox sx={{ width: '100%', height: '100%' }}>
                  <CombinedChart
                    title="Dashboard Overview"
                    ordersData={totalOrders}
                    revenueData={totalRevenue}
                    basecostData={totalBasecost}
                    height="100%"
                  />
                </MDBox>
              );
            })()}
          </Grid>
        </Grid>

        {/* Bảng báo cáo store - Full width bên dưới */}
        <Grid container spacing={3} sx={{ mb: 4 }}>
          <Grid item xs={12}>
            <StoreReportTable
              storeStatistics={dashboard?.storeStatistics || {}}
            />
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
